import React from 'react';

import { IComponent } from '../../../typings/generic-component';
import { makeClassNames } from '../../../utils/styles';
import Cta from '../../atoms/cta/cta';
import './match-cta-row.scss';

const classNames = () =>
  makeClassNames({
    matchCtaRow: 'match-cta-row',
    td: 'match-cta-row__td',
  });

export interface IMatchCtaRow extends IComponent {
  href: string;
}

const MatchCtaRow = ({ children, href }: IMatchCtaRow) => {
  const cn = classNames();

  return (
    <tr className={cn.matchCtaRow}>
      <td className={cn.td} colSpan={100}>
        <Cta href={href} iconPosition="right" mobileButton>
          {children}
        </Cta>
      </td>
    </tr>
  );
};

export default MatchCtaRow;
